import React from 'react';

import styled from '@emotion/styled';
import { media } from '../../services/media';
import { Storyblok, StoryblokSection } from '../../storyblok';

import { Column } from './Column';
import { Container } from '../../components/Container';

export const About = ({
    sectionData,
}: StoryblokSection<Storyblok.Component.About>) => {
    const {
        bubbleContent,
        bubbleTitle,
        leftColumnContent,
        leftColumnTitle,
        component,
    } = sectionData;

    return (
        <Section data-block={component}>
            <Container sizeGroup="size-2">
                <Grid>
                    <Column
                        content={leftColumnContent}
                        title={leftColumnTitle}
                        renderAsBubble={false}
                    />
                    <Column
                        content={bubbleContent}
                        title={bubbleTitle}
                        renderAsBubble
                    />
                </Grid>
            </Container>
        </Section>
    );
};

const Section = styled.section`
    padding: 60px 15px;

    ${media.max('md')} {
        font-size: 16px;
    }

    ${media.between('md', 'lg')} {
        font-size: 18px;
    }

    ${media.between('lg', 'xl')} {
        font-size: 20px;
    }

    ${media.min('xl')} {
        font-size: 22px;
    }
`;

const Grid = styled.div`
    display: grid;

    ${media.max('xl')} {
        grid-template-columns: 1fr;
        gap: 30px;
    }

    ${media.min('xl')} {
        gap: 50px;
        grid-template-columns: 2fr 3fr;
    }
`;
